var _WebFeatureServiceCapabilities;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { createTransformer } from "mobx-utils";
import defined from "terriajs-cesium/Source/Core/defined";
import isDefined from "../../../Core/isDefined";
import loadXML from "../../../Core/loadXML";
import TerriaError from "../../../Core/TerriaError";
import xml2json from "../../../ThirdParty/xml2json";
import { isJsonString } from "../../../Core/Json";
export function getRectangleFromLayer(layer) {
  const bbox = layer.WGS84BoundingBox;
  if (bbox) {
    return {
      west: bbox.westBoundLongitude,
      south: bbox.southBoundLatitude,
      east: bbox.eastBoundLongitude,
      north: bbox.northBoundLatitude
    };
  }
  return undefined;
}

/**
 * Get CapabilitiesService (in WMS form)
 */
function getService(json) {
  var _serviceProviderJson$, _serviceIdentificatio, _serviceProviderJson$2, _serviceProviderJson$3, _serviceProviderJson$4, _serviceProviderJson$5, _serviceProviderJson$6;
  const serviceProviderJson = json["ServiceProvider"];
  const serviceIdentificationJson = json["ServiceIdentification"];
  const serviceAddressJson = serviceProviderJson === null || serviceProviderJson === void 0 || (_serviceProviderJson$ = serviceProviderJson["ServiceContact"]) === null || _serviceProviderJson$ === void 0 || (_serviceProviderJson$ = _serviceProviderJson$["ContactInfo"]) === null || _serviceProviderJson$ === void 0 ? void 0 : _serviceProviderJson$["Address"];
  const service = {
    Title: serviceIdentificationJson === null || serviceIdentificationJson === void 0 ? void 0 : serviceIdentificationJson["Title"],
    Abstract: serviceIdentificationJson === null || serviceIdentificationJson === void 0 ? void 0 : serviceIdentificationJson["Abstract"],
    Fees: serviceIdentificationJson === null || serviceIdentificationJson === void 0 ? void 0 : serviceIdentificationJson["Fees"],
    AccessConstraints: serviceIdentificationJson === null || serviceIdentificationJson === void 0 ? void 0 : serviceIdentificationJson["AccessConstraints"],
    KeywordList: {
      Keyword: serviceIdentificationJson === null || serviceIdentificationJson === void 0 || (_serviceIdentificatio = serviceIdentificationJson["Keywords"]) === null || _serviceIdentificatio === void 0 ? void 0 : _serviceIdentificatio["Keyword"]
    },
    ContactInformation: {
      ContactPersonPrimary: {
        ContactPerson: serviceProviderJson === null || serviceProviderJson === void 0 || (_serviceProviderJson$2 = serviceProviderJson["ServiceContact"]) === null || _serviceProviderJson$2 === void 0 ? void 0 : _serviceProviderJson$2["IndividualName"],
        ContactOrganization: serviceProviderJson === null || serviceProviderJson === void 0 ? void 0 : serviceProviderJson["ProviderName"]
      },
      ContactPosition: serviceProviderJson === null || serviceProviderJson === void 0 || (_serviceProviderJson$3 = serviceProviderJson["ServiceContact"]) === null || _serviceProviderJson$3 === void 0 ? void 0 : _serviceProviderJson$3["PositionName"],
      ContactAddress: {
        Address: serviceAddressJson === null || serviceAddressJson === void 0 ? void 0 : serviceAddressJson["DeliveryPoint"],
        City: serviceAddressJson === null || serviceAddressJson === void 0 ? void 0 : serviceAddressJson["City"],
        StateOrProvince: serviceAddressJson === null || serviceAddressJson === void 0 ? void 0 : serviceAddressJson["AdministrativeArea"],
        PostCode: serviceAddressJson === null || serviceAddressJson === void 0 ? void 0 : serviceAddressJson["PostalCode"],
        Country: serviceAddressJson === null || serviceAddressJson === void 0 ? void 0 : serviceAddressJson["Country"]
      },
      ContactVoiceTelephone: serviceProviderJson === null || serviceProviderJson === void 0 || (_serviceProviderJson$4 = serviceProviderJson["ServiceContact"]) === null || _serviceProviderJson$4 === void 0 || (_serviceProviderJson$4 = _serviceProviderJson$4["ContactInfo"]) === null || _serviceProviderJson$4 === void 0 || (_serviceProviderJson$4 = _serviceProviderJson$4["Phone"]) === null || _serviceProviderJson$4 === void 0 ? void 0 : _serviceProviderJson$4["Voice"],
      ContactFacsimileTelephone: serviceProviderJson === null || serviceProviderJson === void 0 || (_serviceProviderJson$5 = serviceProviderJson["ServiceContact"]) === null || _serviceProviderJson$5 === void 0 || (_serviceProviderJson$5 = _serviceProviderJson$5["ContactInfo"]) === null || _serviceProviderJson$5 === void 0 || (_serviceProviderJson$5 = _serviceProviderJson$5["Phone"]) === null || _serviceProviderJson$5 === void 0 ? void 0 : _serviceProviderJson$5["Facsimile"],
      ContactElectronicMailAddress: serviceProviderJson === null || serviceProviderJson === void 0 || (_serviceProviderJson$6 = serviceProviderJson["ServiceContact"]) === null || _serviceProviderJson$6 === void 0 || (_serviceProviderJson$6 = _serviceProviderJson$6["ContactInfo"]) === null || _serviceProviderJson$6 === void 0 || (_serviceProviderJson$6 = _serviceProviderJson$6["Address"]) === null || _serviceProviderJson$6 === void 0 ? void 0 : _serviceProviderJson$6["ElectronicMailAddress"]
    }
  };
  return service;
}
function getFeatureTypes(json) {
  var _json$FeatureTypeList;
  let featureTypesJson = (_json$FeatureTypeList = json.FeatureTypeList) === null || _json$FeatureTypeList === void 0 ? void 0 : _json$FeatureTypeList.FeatureType;
  if (!isDefined(featureTypesJson)) {
    return [];
  }
  if (!Array.isArray(featureTypesJson)) {
    featureTypesJson = [featureTypesJson];
  }
  return featureTypesJson.map(json => {
    var _json$WGS84BoundingBo, _json$WGS84BoundingBo2, _json$Keywords;
    const lowerCorner = (_json$WGS84BoundingBo = json["WGS84BoundingBox"]) === null || _json$WGS84BoundingBo === void 0 ? void 0 : _json$WGS84BoundingBo["LowerCorner"].split(" ");
    const upperCorner = (_json$WGS84BoundingBo2 = json["WGS84BoundingBox"]) === null || _json$WGS84BoundingBo2 === void 0 ? void 0 : _json$WGS84BoundingBo2["UpperCorner"].split(" ");
    let outputFormats;
    if (isDefined(json.OutputFormats)) {
      outputFormats = Array.isArray(json.OutputFormats) ? json.OutputFormats.map(o => o.Format) : [json.OutputFormats.Format];
    }
    return {
      Title: json.Title,
      Name: json.Name,
      Abstract: json.Abstract,
      Keyword: (_json$Keywords = json["Keywords"]) === null || _json$Keywords === void 0 ? void 0 : _json$Keywords["Keyword"],
      WGS84BoundingBox: {
        westBoundLongitude: lowerCorner && parseFloat(lowerCorner[0]),
        southBoundLatitude: lowerCorner && parseFloat(lowerCorner[1]),
        eastBoundLongitude: upperCorner && parseFloat(upperCorner[0]),
        northBoundLatitude: upperCorner && parseFloat(upperCorner[1])
      },
      OutputFormats: outputFormats
    };
  }) || [];
}
function getOutputTypes(json) {
  var _json$OperationsMetad;
  const outputTypes = (_json$OperationsMetad = json.OperationsMetadata) === null || _json$OperationsMetad === void 0 || (_json$OperationsMetad = _json$OperationsMetad.Operation) === null || _json$OperationsMetad === void 0 || (_json$OperationsMetad = _json$OperationsMetad.find(op => op.name === "GetFeature")) === null || _json$OperationsMetad === void 0 || (_json$OperationsMetad = _json$OperationsMetad.Parameter) === null || _json$OperationsMetad === void 0 || (_json$OperationsMetad = _json$OperationsMetad.find(p => p.name === "outputFormat")) === null || _json$OperationsMetad === void 0 ? void 0 : _json$OperationsMetad.Value;
  if (!isDefined(outputTypes)) {
    return;
  }
  return Array.isArray(outputTypes) ? outputTypes : [outputTypes];
}
/**
 * Get the coordinate systems (srsName) supported by the WFS service for each layer.
 * @param json
 * returns an object with an array of srsNames for each layer. The first element is the defaultSRS as specified by the WFS service.
 * TODO: For catalog items that specify which layer we are interested in, why build the array describing the srsNames for all the other layers too?
 */
function getSrsNames(json) {
  var _json$FeatureTypeList2;
  const layers = (_json$FeatureTypeList2 = json.FeatureTypeList) === null || _json$FeatureTypeList2 === void 0 ? void 0 : _json$FeatureTypeList2.FeatureType;
  let srsNamesByLayer = [];
  if (Array.isArray(layers)) {
    srsNamesByLayer = layers.map(buildSrsNameObject);
  } else {
    var _json$FeatureTypeList3;
    srsNamesByLayer.push(buildSrsNameObject((_json$FeatureTypeList3 = json.FeatureTypeList) === null || _json$FeatureTypeList3 === void 0 ? void 0 : _json$FeatureTypeList3.FeatureType));
  }
  return srsNamesByLayer;
}

/**
 * Helper function to build individual objects describing the allowable srsNames for each layer in the WFS
 * @param layer
 */
function buildSrsNameObject(layer) {
  const srsNames = [];
  if (isJsonString(layer.DefaultSRS)) srsNames.push(layer.DefaultSRS);
  if (Array.isArray(layer.OtherSRS)) layer.OtherSRS.forEach(item => {
    if (isJsonString(item)) srsNames.push(item);
  });else if (isJsonString(layer.OtherSRS)) srsNames.push(layer.OtherSRS);
  return {
    layerName: layer.Name,
    srsArray: srsNames
  };
}
export default class WebFeatureServiceCapabilities {
  constructor(_xml, json) {
    _defineProperty(this, "service", void 0);
    _defineProperty(this, "outputTypes", void 0);
    _defineProperty(this, "featureTypes", void 0);
    _defineProperty(this, "srsNames", void 0);
    this.service = getService(json);
    this.outputTypes = getOutputTypes(json);
    this.featureTypes = getFeatureTypes(json);
    this.srsNames = getSrsNames(json);
  }

  /**
   * Finds the layer in GetCapabilities corresponding to a given layer name. Names are
   * resolved as foll
   *    * The layer has the exact name specified.
   *    * The layer name matches the name in the spec if the namespace portion is removed.
   *    * The name in the spec matches the title of the layer.
   *
   * @param {String} name The layer name to resolve.
   * @returns {CapabilitiesLayer} The resolved layer, or `undefined` if the layer name could not be resolved.
   */
  findLayer(name) {
    // Look for an exact match on the name.
    let match = this.featureTypes.find(ft => ft.Name === name);
    if (!match) {
      const colonIndex = name.indexOf(":");
      if (colonIndex >= 0) {
        // This looks like a namespaced name.  Such names will (usually?) show up in GetCapabilities
        // as just their name without the namespace qualifier.
        const nameWithoutNamespace = name.substring(colonIndex + 1);
        match = this.featureTypes.find(ft => ft.Name === nameWithoutNamespace);
      }
    }
    if (!match) {
      // Try matching by title.
      match = this.featureTypes.find(ft => ft.Title === name);
    }
    return match;
  }
}
_WebFeatureServiceCapabilities = WebFeatureServiceCapabilities;
_defineProperty(WebFeatureServiceCapabilities, "fromUrl", createTransformer(url => {
  return loadXML(url).then(function (capabilitiesXml) {
    const json = xml2json(capabilitiesXml);
    if (!defined(json.ServiceIdentification)) {
      throw new TerriaError({
        title: "Invalid GetCapabilities",
        message: "The URL ".concat(url, " was retrieved successfully but it does not appear to be a valid Web Feature Service (WFS) GetCapabilities document.") + "\n\nEither the catalog file has been set up incorrectly, or the server address has changed."
      });
    }
    return new _WebFeatureServiceCapabilities(capabilitiesXml, json);
  });
}));